import { PageHeaderSection } from "../../models/page-builder/page-header-section.model";

export const MOCK_PAGE_HEADER_SECTION: PageHeaderSection = {
  type: "page-header",
  content: {
    headings: {
      preTitle: "Welcome to jungle",
      preTitleColor: "#333",
      title: "My Awesome Website with all the features",
      titleColor: "#0066cc",
      subTitle:
        "Descriptipn Lorem ipsum dolor sit amet consectetur. Elit ut condimentum pulvinar elementum. In neque eu semper molestie nulla dis.",
      subTitleColor: "#666",
    },
    media: {
      mediaFileUrl: {
        type: "video",
        originalFileName: "background-original.MP4",
        uploadFileName: "background.Mp4",
        url: "https://d1vtcg1116q8lj.cloudfront.net/och-app/website-builder/default-sections/page-header.jpg",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
    },
    buttons: {
      items: [
        {
          buttonText: "Explore",
          buttonLink: "https://itsmekamal.com",
          textColor: "#333",
          backgroundColor: "#009688",
          borderColor: "#0096",
        },
        {
          buttonText: "Get Started",
          buttonLink: "https://onlinecoursehost.com",
          textColor: "#000",
          backgroundColor: "#ff5722",
          borderColor: "#000",
        },
      ],
      buttonHint: "Click here to get started!",
      buttonHintColor: "#000",
    },
  },
  design: {
    layout: "card",
    textAlignment: "center",
    mediaAlignment: "topBottom",
    appearance: {
      FeatureBackgroundColor: "#fff",
      cardBackgroundColor: "#F1F3F5",
      backgroundImageUrl: {
        type: "image",
        originalFileName: "background-original.jpg",
        uploadFileName: "background.jpg",
        url: "https://picsum.photos/3000/2000",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.2,
          blending: "normal",
          blur: 3,
          grayScale: 10,
          contrast: 100,
        },
      },
    },
  },
};
